
import React from 'react';
import ToastMessage from '../../components/shared/Toasts';

const failPdf = (
    <div>
    <ToastMessage icon="exclamation">
    <div id="preference-error">
        Pdf doesn't exist
    </div>
    </ToastMessage>
</div>
);

export default {
    failPdf
};
